  import React, { useState,useEffect} from "react";
import LayerAdmin from "../LayerAdmin";
import { toast } from "react-toastify";
import ButtonLoader from "../../zamzam/components/ButtonLoader";
import { useNavigate } from "react-router-dom";
import URL_MAPPING from "../../../routes/constants";
import { addNewTerritory,getDropdowns } from "../api/territory";
import Dropdown from '../components/Dropdown'
const AddNewTerritory = () => {
  const [formData, setFormData] = useState({
    emp_id: "",
    identifiers:"",
    // session_entity_key: "",
    // territory_entity_key: "",
  });
  const [loading, setLoading] = useState(false);
  const [invalidFields, setInvalidFields] = useState<string[]>([]);
const [values, setValues] = useState<any>([]);
  const navigate = useNavigate();
  const handleChangeDropdown = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const options = Array.from(new Set(values as string[])).map((val) => ({
    value: val,
    name: val,
  }));
  
  
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getInputClass = (field: string) =>
    `w-full border px-3 py-2 rounded ${
      invalidFields.includes(field) ? "border-red-500" : ""
    }`;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const payload = {
      emp_id: formData.emp_id,
      territory_identifier: formData.identifiers,
    
    };

    try {
      setLoading(true);
      const emptyFields = Object.entries(formData)
        .filter(([_, value]) => value === null || value === "")
        .map(([key]) => key);

      setInvalidFields(emptyFields);

      if (emptyFields.length > 0) {
        toast.error("Please fill all required fields.");
        return;
      }
      const response = await addNewTerritory(payload);
      if (!response) {
        toast.error("No data received or malformed response");
        console.warn("No data received or malformed response:", response);
        return;
      }
      toast.success(response?.message);
      setTimeout(() => {
        navigate(URL_MAPPING.TERRITORY);
      }, 2000);
    } catch (error: any) {
      console.error("Failed to fetch territory data:", error);
      if (error?.response?.status === 404) {
        toast.error("Route not found, Please try again later",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else if (error?.response?.status === 500) {
        toast.error(error.response.data.detail,{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg,{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          }));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.",{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          });
        }
      }
    } finally {
      setLoading(false);
    }
  };


   useEffect(() => {
      const fetchMappings = async () => {
        try {
          const res = await getDropdowns();
          if (!res) {
            toast.error("No data received or malformed response");
            console.warn("No data received or malformed response:", res);
            return;
          }
          setValues(res || []);
        } catch (error: any) {
          console.error("Failed to fetch employee data:", error);
          if (error?.response?.status === 404) {
            toast.error("Route not found, Please try again later");
          } else if (error?.response?.status === 500) {
            toast.error("Error while fetching the employee");
          } else {
            const detail = error?.response?.data?.detail;
            if (Array.isArray(detail)) {
              detail.forEach(err => toast.error(err.msg));
            } else {
              toast.error(detail?.msg || detail || "An unexpected error occurred.");
            }
          }
        } finally {
          setLoading(false);
        }
      };
  
      fetchMappings();
    }, []);
  return (
    <LayerAdmin>
      <div className="flex items-center px-5 pt-5 gap-3">
        <button
          onClick={() => window.history.back()}
          className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            width="10"
            height="10"
            viewBox="0 0 256 256"
            xmlSpace="preserve"
          >
            <g
              style={{
                stroke: "none",
                strokeWidth: 0,
                strokeDasharray: "none",
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 10,
                fill: "none",
                fillRule: "nonzero",
                opacity: 1,
              }}
              transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
            >
              <polygon
                points="20.48,45 59.75,90 69.52,81.48 37.69,45 69.52,8.52 59.75,0 "
                style={{
                  stroke: "none",
                  strokeWidth: 1,
                  strokeDasharray: "none",
                  strokeLinecap: "butt",
                  strokeLinejoin: "miter",
                  strokeMiterlimit: 10,
                  fill: "rgb(0,0,0)",
                  fillRule: "nonzero",
                  opacity: 1,
                }}
                transform="  matrix(1 0 0 1 0 0) "
              />
            </g>
          </svg>
        </button>
        <h3 className="text-xl font-bold text-gray-700">Add Territory</h3>
      </div>
      <form onSubmit={handleSubmit} className="p-4 lg:w-1/3 sm:w-full">
        <div className="my-2">
          <label className="block font-semibold mb-1">Employee ID *</label>
          <input
            type="text"
            name="emp_id"
            value={formData.emp_id}
            onChange={handleChange}
            className={getInputClass("emp_id")}
            placeholder="Employee Id"
          />
        </div>


  <div className="my-2">
          <label className="block font-semibold mb-1">Select Identifiers *</label>
      
          <Dropdown
            name="identifiers"
            value={formData.identifiers}
            onChange={handleChangeDropdown}
            options={options}
            className={getInputClass("identifiers")}
            placeholder="Select Identifiers "
            searchable={true}
            // multiple={true}
          />
          {/* <select
            name="identifiers"
            value={formData.identifiers}
            onChange={handleChange}
            className={getInputClass("identifiers")}
          >
            <option value="">Select Identifiers </option>
            {values.map((values: string) => (
              <option key={values} value={values}>
                {values}
              </option>
            ))}
          </select> */}
        </div>
        <button
          type="submit"
          disabled={loading}
          className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 flex items-center gap-2"
        >
          Add New Territory {loading && <ButtonLoader />}
        </button>
      </form>
    </LayerAdmin>
  );
};

export default AddNewTerritory;
